import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { store, persistor } from "./store";
import AuthRoutes from "./routes/AuthRoutes";
import ProtectedRoute from "./routes/ProtectedRoute";
import DashboardLayout from "./layout/DashboardLayout";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <div className="App">
            <Routes>
              {/* Auth Routes */}
              <Route path="/signin" element={<AuthRoutes />} />
              <Route path="/forgot-password" element={<AuthRoutes />} />
              <Route path="/reset-password" element={<AuthRoutes />} />

              {/* Protected Admin Routes */}
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              />

              {/* Legacy Dashboard Route - Redirect to new admin structure */}
              <Route
                path="/dashboard"
                element={<Navigate to="/admin/dashboard" replace />}
              />

              {/* Fallback - Redirect to signin */}
              <Route path="*" element={<Navigate to="/signin" replace />} />
            </Routes>

            {/* Toast Notifications */}
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </div>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
